import React, { Ref, useCallback, useEffect, useState } from 'react'
import useIsMounted from 'ismounted'

import { API } from 'lib/gravy'
import Select, { SelectProps } from 'components/ui/Select/Select'
import { UpgradeReason } from 'types/models'

const UpgradeReasonSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const [upgradeReasons, setUpgradeReasons] = useState<UpgradeReason[]>()
    const isMounted = useIsMounted()

    const options = useCallback(() => {
      return upgradeReasons.map((cancelReason) => {
        return { value: cancelReason.id, text: `${cancelReason.displayName}` }
      })
    }, [upgradeReasons])

    useEffect(() => {
      API.get('upgrade_reasons').then((response) => {
        if (isMounted.current) {
          setUpgradeReasons(response.data)
        }
      })
    }, [])

    if (!upgradeReasons) {
      return <Select {...props} />
    }

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options()} {...props} ref={ref} />
      </div>
    )
  }
)

export default UpgradeReasonSelect
